var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4355 3.8623L15.7754 12.5225L16.1289 12.876L24.2402 20.9883L20.8906 24.3369L12.4268 15.873L12.0732 16.2266L3.8623 24.4355L0.707031 21.2803L9.26953 12.7178L0.804688 4.25293L4.15527 0.902344L12.6201 9.36719L21.2803 0.707031L24.4355 3.8623Z",
    fill: "white",
    stroke: "#0082CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.ebf5b7a7780308dc8db0884e4eb0ea18.svg";
export { ForwardRef as ReactComponent };